import { Validation } from './validation';

export const ValidationFacebookId: Validation[] = [
  new Validation(
    (v) => Boolean((v.match(/^[a-z0-9.]+$/) && (v.length <= 255)) || v.length === 0),
    '半角英数字(小文字のみ)で5〜255文字以内で入力してください。記号は「.」のみ使用できます',
  ),
];
